import { FlightSegment } from '@prisma/client';

export const prettyStopCount = (stopCount: number) => {
  if (stopCount === 0) return 'Nonstop';
  if (stopCount === 1) return '1 Stop';
  return `${stopCount} Stops`;
};

export const prettyPath = (segments: FlightSegment[], joiner: string = '-') => {
  const stops =
    segments.reduce((acc, node, index) => {
      if (index === 0) acc.push(node.origin_airport_id);
      acc.push(node.destination_airport_id);
      return acc;
    }, []) || [];
  return stops.join(joiner);
};
